<div class="market-history">

    <h2 class="heading pb-2">
        <i class="ion-md-link text-muted mx-2 align-self-center" style="font-size: 20px; vertical-align: middle;"
            *ngIf="isLinked"></i>

        {{"chart"|translate}}
        <span class="widget-reuters mx-2" matTooltipPosition="left" [matTooltip]='companyName'
            matTooltipClass="custom-tooltip" *ngIf="reuters">
            {{reuters}}
        </span>
    </h2>

    <div *ngIf="symbolCode"  [id]='symbol'></div>

    <div class="row no-data p-5 m-0" style="height: 85%;" *ngIf="symbolCode == undefined || symbolCode == null">
        <div class="col-md-12">
            <img class="empty-state" style="width: 15% !important;" src="/assets/img/noData.png" />
            <div class="col-sm-12">
                <h6 class="nodata-msg"> {{"select-company-hint"|translate}} </h6>
            </div>
        </div>
    </div>
</div>
